let code = 'os';
let codeAPI = 'os';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
};